export default __webpack_public_path__ + "static/media/view-list.803816c5.svg";